import { authRequest } from './index.js'

export async function get_module(trait_id){
  let data
  await authRequest.get(
    '/traits/' + trait_id + '/show_module'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    data = {error: true, result: error.response?.data || error.message || 'Unknown error'}
  })
  return data
}

export async function get_max_val(trait_id){
  let data
  await authRequest.get(
    '/traits/' + trait_id + '/max_value'
  )
  .then(function(result){
    data = {result, error: false}
  })
  .catch(function (error){
    data = {error: true, result: error.response?.data || error.message || 'Unknown error'}
  })
  return data
}